import {
  STOCK_ERROR,
  STOCK_PRODUCT_LIST,
  UPDATE_IS_STOCK_NOTIFY,
} from '../Actions/ConfigStock.action';
import { error as errorReducer } from './Error.reducer';

const defaultState = {
  articlesList: [],
  errors: {},
};

export const articleStock = (state = defaultState, action) => {
  switch (action.type) {
    case STOCK_PRODUCT_LIST:
      return {
        ...state,
        articlesList: action.payload.articlesList,
      };
    case STOCK_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case UPDATE_IS_STOCK_NOTIFY:
      return {
        ...state,
        articlesList: state.articlesList.map((article) =>
          article.variantSystemId === action.payload.variantSystemId
            ? { ...article, isStockNotify: action.payload.isStockNotify }
            : article
        ),
      };
    default:
      return state;
  }
};
